module.exports = __webpack_public_path__ + "img/report-2.24edf0d2.jpg";